import { useQuery } from 'react-query';
import { getAllSolutionProducts, getAllProducts, getLedgerSystems } from '~/api/product';

export const useProductsBySolutionId = (solutionId?: string) => {
  return useQuery(['solutionProducts', solutionId], () => getAllSolutionProducts(solutionId!), {
    enabled: !!solutionId,
  });
};

export const useGetAllProducts = () => {
  return useQuery(['products'], () => getAllProducts());
};

export const useGetLedgerSystems = () => {
  return useQuery(['ledgerSystems'], () => getLedgerSystems());
};
